import rgba from 'polished/lib/color/rgba';
import { css } from 'styled-components';
var fontMap = {
  Title1: {
    size: 'xxlarge',
    height: 'xxlarge',
    weight: 'bold'
  },
  Title2: {
    size: 'xlarge',
    height: 'xlarge',
    weight: 'bold'
  },
  Title2Subtitle: {
    size: 'medium',
    height: 'medium',
    weight: 'semiBold'
  },
  Title3: {
    size: 'large',
    height: 'large',
    weight: 'bold'
  },
  Title3Subtitle: {
    size: 'base',
    height: 'base',
    weight: 'regular'
  },
  Title4: {
    size: 'medium',
    height: 'medium',
    weight: 'bold'
  },
  Title5: {
    size: 'base',
    height: 'base',
    weight: 'bold'
  },
  Title6: {
    size: 'small',
    height: 'small',
    weight: 'bold'
  },
  TextLarge: {
    size: 'medium',
    height: 'medium',
    weight: 'regular'
  },
  TextNormal: {
    size: 'base',
    height: 'base',
    weight: 'regular'
  },
  TextSmall: {
    size: 'small',
    height: 'small',
    weight: 'regular'
  },
  TextExtraSmall: {
    size: 'xsmall',
    height: 'xsmall',
    weight: 'regular'
  }
};
export var fontSize = function fontSize(descriptor) {
  return css(["font-size:", ";"], function (_ref) {
    var theme = _ref.theme;
    return theme.commons.font.sizes[descriptor];
  });
};
export var fontWeight = function fontWeight(descriptor) {
  return css(["font-weight:", ";"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.commons.font.weights[descriptor];
  });
};
export var fontHeight = function fontHeight(descriptor) {
  return css(["line-height:", ";"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.commons.font.heights[descriptor];
  });
};
export var font = function font(descriptor) {
  var correctFont = fontMap[descriptor];
  return css(["", " ", " ", ""], fontSize(correctFont.size), fontWeight(correctFont.weight), fontHeight(correctFont.height));
};
export var color = function color(colorName) {
  return function (_ref4) {
    var theme = _ref4.theme;
    return theme.commons.colors[colorName];
  };
};
export var colorAlpha = function colorAlpha(colorName, theme, alpha, fallbackColor) {
  return theme.tokensWithValues ? rgba(theme.tokensWithValues[colorName], alpha) : fallbackColor;
};